import { get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import { GetProductApiV2ParameterBase } from "@insite/client-framework/Services/ProductServiceV2";
import { PartCollectionModel, WholegoodCollectionModel } from "@store/Types/Parts";

const productsUrl = "/api/v2/products";

export interface GetPartCollectionApiParameter extends GetProductApiV2ParameterBase, HasPagingParameters {
    productId: string;
}
export interface GetWholegoodCollectionApiParameter extends GetProductApiV2ParameterBase, HasPagingParameters {
    productSKU: string;
}

export function getPartCollection(parameter: GetPartCollectionApiParameter) {
    const { productId, ..._parameter } = parameter;

    return get<PartCollectionModel>(`${productsUrl}/${productId}/parts`, _parameter);
}


export function getWholegoodCollection(parameter: GetWholegoodCollectionApiParameter) {
    const { productSKU, ..._parameter } = parameter;

    return get<WholegoodCollectionModel>(`${productsUrl}/${productSKU}/wholegoods`, _parameter);
}
